import React from 'react'
import Sign_out_squre from "../../../assets/images/Sign_out_squre.svg";
import { NEW_URL } from '../../../constants/applicationConstants';
import Sidebar from "../../dashboard/opsDashboard/sidebar/sidebar.js";
import { Footer } from '../../common/footer/footer';
import { Pagination } from '../../common/pagination/pagination';
import { convertToCanadianDateTime, ModulePermission } from '../../../shared/helper';

const PendingQuestionJsx = (props) => {
  const {
    data,meta1,meta2,    
    onButtonClick,
    onAnsweredQuestionClick,
    onPaginationButtonClick
  } = props;

  return (
    <>
      <section className="entiredashboard">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-3">


              <div className="dashboardleftpanel martop40">

                <div className="dashboardlink martop40">
                  <Sidebar />
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-sm-9">
              <div className="dashboardrightpanel martop40 mb-5">
                <div className="dashboardrightpannerinner">
                  <div className="dashboardrightpannerinnerleft">
                    {/* <h2 className="h2_style font-weight-600">QnA - Pending Questions</h2>
                    <h5 className="h5_style">Providing quality answers enhances your reputation and increases the likelihood of attracting new clients
</h5>
                    <h5 className="h5_style">Also, it helps you gain insight into customer’s needs, pain points, and interests.</h5>
                    <h5 className="h5_style fst-italic fw-light">Don’t miss the chances of securing new business. Answer all your pending questions now!</h5> */}
                  </div>
                  <div className="dashboardrightpannerinnerright">
                    <div className="signout">
                      <a href="#logout">
                        <img src={Sign_out_squre} alt={' '} /><span className="title">Logout</span>
                      </a>
                    </div>
                   
                  </div>
                </div>
                <div className="myexpertnav myaccountnav qnanav martop40">
                  <ul>
                    <li className="active">Pending Questions<span>{meta1?.totalCount}</span></li>
                    <li onClick={() => onAnsweredQuestionClick()}>Approved Questions<span>{meta2?.totalCount}</span></li>
                  </ul>
                </div>

                <div className="questioninner mt-4">

                  {
                    data?.map(pendingQues => {
                      return <div className="questioninnerin">
                        <div className="d-flex questioninnerinbottom">
                          <div className="expertquestiondetails">
                            <div className="expertuser"><img src={!data?.imageUr ? `https://ui-avatars.com/api/?name=${pendingQues?.fullName}&rounded=true` : `${NEW_URL}/${data?.imageUr}`} alt={' '} /></div>
                            <div className="questionid"><span>Question ID -</span> {pendingQues?.askExpertQuestionUserResponseId}
                              <div className="questiondate">{convertToCanadianDateTime(pendingQues.createdAt)}</div></div>

                          </div>

                        </div>
                        <p>{pendingQues?.question}</p>
                        <div className="d-flex questioninnerinbottom">
                          <div className="expertquestiondetails catspecial">
                            <span>{`Category: ${pendingQues.parentInstitutionCategory}`}</span>  <span>{`Subcategory: ${pendingQues?.subInstitutionCategory?.name}`}</span>

                          </div>
                          <div className="d-flex catspecial">
                            <button disabled={ModulePermission().canManageQuestionRead }  type="button" className="ctaonebutton" onClick={() => onButtonClick(pendingQues.askExpertQuestionUserResponseId, 'accepted')}>Approved</button><button disabled={ModulePermission().canManageQuestionRead } type="button" className="ctatwobutton" onClick={() => onButtonClick(pendingQues.askExpertQuestionUserResponseId, 'rejected')}>Reject</button>
                          </div>
                        </div>
                      </div>

                    })
                  }

                </div>
                {data?.length > 0 && <Pagination
            limit={10}
            totalCount={meta1?.totalCount}
            onPaginationButtonClick={onPaginationButtonClick}
          />}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

    </>

  );
};

export default PendingQuestionJsx;